const plans = [
    {
        id: 1,
        codigo: 'FM30',
        title: 'FaleMais 30',
        min: 30
    },
    {
        id: 2,
        codigo: 'FM60',
        title: 'FaleMais 60',
        min: 60
    },
    {
        id: 3,
        codigo: 'FM120',
        title: 'FaleMais 120',
        min: 120
    },
];

export default plans;